import { useState, useLayoutEffect } from "react";
import { Button } from "@douyinfe/semi-ui";
import { useNavigate } from "react-router-dom";
import logoImg from "@assets/home-image/logo.svg";
import { ReactComponent as GlobalIcon } from "@assets/icons/global_icon.svg";
import { useTranslation } from "react-i18next";
import { headerConfig } from "@services/home/config/home.config";
import { useSearchParams, Link } from "react-router-dom";
import { HeaderLanModel } from "@services/home/model/home.model";
import { DEPLOY_TYPE } from "@config/global.config";
import styles from "./index.module.scss";

const HomeHeader = () => {
  const { i18n } = useTranslation("layouts");
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [config, setConfig] = useState<HeaderLanModel>();

  const language = searchParams.get("lang");

  const changeLanguage = (lang: "en" | "zh") => {
    i18n.changeLanguage(lang);
    setSearchParams((params) => {
      params.set("lang", lang);
      return params;
    });
  };

  function login() {
    navigate("/login");
  }

  function applyTrial() {
    navigate("/index/trial");
  }

  useLayoutEffect(() => {
    if (language) {
      changeLanguage(language === "en" ? "en" : "zh");
    }
  }, [language]);

  useLayoutEffect(() => {
    if (i18n.resolvedLanguage) {
      setConfig(headerConfig[i18n.resolvedLanguage]);
    }
  }, [i18n.resolvedLanguage]);

  return (
    <div className={styles.header}>
      {config && (
        <div className={styles.wrapper}>
          <div>
            <Link to="/index">
              <img src={logoImg} />
            </Link>
          </div>
          <div className={styles.right}>
            <Button
              theme="borderless"
              type="tertiary"
              icon={<GlobalIcon />}
              className={styles.lang}
              onClick={() =>
                changeLanguage(i18n.resolvedLanguage === "en" ? "zh" : "en")
              }
            >
              {config.lan}
            </Button>
            {DEPLOY_TYPE !== "private" && (
              <Button
                theme="solid"
                type="primary"
                className={styles.btn}
                onClick={applyTrial}
              >
                {config.applyText}
              </Button>
            )}

            <Button
              theme="light"
              type="tertiary"
              className={`reset-btn ${styles.btn}`}
              onClick={login}
            >
              {config.btnText}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeHeader;
